import { type AnyRouter } from "@tanstack/react-router";
import { type AuthClient } from "~/api/AuthClient";
import { type AuthUser } from "~/api/auth/AuthUser";

export const subscribeAuthRouter = (
  authClient: AuthClient,
  router: AnyRouter,
) => {
  const onStateChange = (current: AuthUser, previous: AuthUser) => {
    if (
      current?.isAuthenticated &&
      !previous?.isAuthenticated &&
      router.state.matches.length > 0
    ) {
      void router.invalidate();
    }
  };
  authClient.on("stateChange", onStateChange);
  return () => {
    authClient.off("stateChange", onStateChange);
  };
};
